import React from 'react';

const AlertsView = () => {
    return <></>
};

export default AlertsView;